import MaterialIcon from '@components/common/MaterialIcon';
import type React from 'react';

interface TextsGroupProps {
  title: string;
  icon: string;
  description?: string;
  // The first group sits right under the section title, so it needs no divider.
  isFirst?: boolean;
  children: React.ReactNode;
}

// One block of the webclient texts, named after the part of the widget it
// fills in.
const TextsGroup: React.FC<TextsGroupProps> = ({
  title,
  icon,
  description,
  isFirst = false,
  children,
}) => {
  return (
    <div className={isFirst ? '' : 'border-t border-gray-200 pt-3 mt-3'}>
      <p className='flex items-center gap-1 text-xs font-semibold text-primary-base mb-1'>
        <MaterialIcon
          icon={icon}
          classes={['text-base', 'text-primary-base']}
        />
        {title}
      </p>
      {description && (
        <p className='text-pico text-gray-400 italic -mt-1 mb-2'>
          {description}
        </p>
      )}
      {children}
    </div>
  );
};

export default TextsGroup;
